import Jasmia121 from '../../../../src/media/SCG/Jasmia/12/Jasmia 12.webp'
import Jasmia122 from '../../../../src/media/SCG/Jasmia/12/Jasmia 12 D.webp'
import Jasmia123 from '../../../../src/media/SCG/Jasmia/12/Jasmia 12 P.webp'
import Jasmia124 from '../../../../src/media/SCG/Jasmia/12/12b Jasmia (1).png'

const Jasmia12images =[
Jasmia121,Jasmia122,Jasmia123,Jasmia124
]

export default Jasmia12images;